import React, { useState } from "react";
import styles from "../Serving_Links/Serving_Links.module.css";
import serving_Data from "../../Data/RO-landing.json";

const Serving_Links = () => {
  const [limit, setLimit] = useState(22);
  let api_data = serving_Data[0].internalLinks.servingAreas;

  return (
    <div className={styles.container}>
      <div className={styles.heading}> Serving in</div>
      <div className={styles.inner}>
        {api_data.slice(0, limit).map((name, index) => {
          return (
            <div className={styles.list}>
              <a href={name.link} target={"_blank"}>
                *{name.anchorText}
              </a>
            </div>
          );
        })}
        <button onClick={() => setLimit(limit + 6)}>More......</button>
      </div>
    </div>
  );
};

export default Serving_Links;
